module.exports = __webpack_public_path__ + "static/media/chuyinshan_package.59441cf9.webp";